$ = require 'jquery'
{ TrelloStorage } = require '@trello/storage'
_ = require 'underscore'

module.exports = window.Logger = new class
  constructor: ->
    @enabled = TrelloStorage.get('loggers') ? {}
    @historyMap = {}
    @logHistory = false
    @timeSpent = {}
    @timing = {}

  log: (region, args...) ->
    if (!console?.log)
      return

    isRegionEnabled = false

    if args.length == 0
      isRegionEnabled = true
      args.push(region)
      region = 'all'
    else
      isRegionEnabled = @enabled['all'] || @enabled[region]

    if (isRegionEnabled)
      if (args.length == 1 && _.isArray(args[0]))
        args = args[0]

      args.unshift(region)
      args.unshift(new Date())
      if $('#trello-root').is('.chrome')
        console.log(args)
      else
        console.dir(args)

    if @logHistory
      @historyMap[region] ?= []
      @historyMap[region].push(args)
    return

  enable: (region = 'all') ->
    @enabled[region] = true
    @save()
    return

  disable: (region = 'all') ->
    delete @enabled[region]
    @save()
    return

  disableAll: ->
    @enabled = {}
    @save()
    return

  enableAll: ->
    @enabled['all'] = true
    @save()
    return

  history: (region) ->
    if region of @historyMap then for args in @historyMap[region]
      console?.log?(args)
    return

  list: ->
    console?.log?(_.keys(@historyMap))
    return

  save: ->
    TrelloStorage.set('loggers', @enabled)
    return

  time: (name) ->
    @timing[name] = performance.now()

  endTime: (name) ->
    delta = performance.now() - @timing[name]
    @timeSpent[name] ?= 0
    @timeSpent[name] += delta
